import React from 'react'
import ContentHeader from '@Components/ContentHeader'

const SongwriterRegistrationHeader = () => (
    <ContentHeader
        title="Songwriter Name"
        descriptionElement={
            <>
                <p>
                    To make sure we find the correct songs (also known as musical works) associated with your songwriter
                    name, we need some information from you!
                </p>
                <p>
                    Use the form below to enter the most recent name you have written songs under and a Writer IPI if
                    you have one.
                </p>
                <p>
                    <b>Note:</b> If you have written under pseudonyms or variations of your name, you can search for
                    them in the next step.
                </p>
            </>
        }
    />
)

export default SongwriterRegistrationHeader
